import { AloftPrice, AloftPriceJSON, orUndefined } from '@aloft/toolkit-shared';
import { Flex, Typography } from '@aloft/toolkit-sui';

import { FieldPath, useWatch } from 'react-hook-form';

import { PropertyGridForm } from '../types.ts';
import { readOnlyFieldTypographyProps } from './consts.ts';
import { PropertyGridFieldProps } from './types.ts';

export const ReadOnlyUnitRateField = ({
  columnIndex,
  field,
  colSpan = 1,
  control,
}: PropertyGridFieldProps) => {
  const { unitRate } = field;

  const unitRateFieldName =
    `columns.${columnIndex}.propertyData.editableData.salesComparison.unitRates.${unitRate?.key}` as FieldPath<PropertyGridForm>;

  const storedUnitRate = useWatch({ control, name: unitRateFieldName }) as
    | AloftPriceJSON
    | undefined;

  if (!unitRate) {
    return (
      <Typography
        {...readOnlyFieldTypographyProps}
        __dangerDoNotUseSx={{
          ...readOnlyFieldTypographyProps.__dangerDoNotUseSx,
          gridColumn: `span ${colSpan}`,
        }}
      >
        -
      </Typography>
    );
  }

  const displayRate = orUndefined(AloftPrice.schema.parse)(storedUnitRate);

  return (
    <Flex
      alignItems="center"
      justifyContent="space-between"
      __dangerDoNotUseSx={{
        ...readOnlyFieldTypographyProps.__dangerDoNotUseSx,
        gridColumn: `span ${colSpan}`,
        paddingRight: '6px',
      }}
    >
      <Typography {...readOnlyFieldTypographyProps} __dangerDoNotUseSx={undefined}>
        {displayRate?.toString(true) ?? '-'}
      </Typography>
      {unitRate.label && displayRate && (
        <span
          style={{
            fontSize: '12px',
            lineHeight: '1',
            color: 'inherit',
            whiteSpace: 'nowrap',
            userSelect: 'none',
            flexShrink: 0,
          }}
        >
          {unitRate.label}
        </span>
      )}
    </Flex>
  );
};
